import { Component, OnInit, OnDestroy, Input, EventEmitter, Output } from '@angular/core';
import { RightSideDrawerService } from '../../shared/right-side-drawer/right-side-drawer.service';
import { AdminClientUsersService } from 'src/app/admin/admin-client-users/admin-client-users.service';
import { ToastrService } from '@kpmg-tax/ui';
import { Messages } from '../../shared/constants/messages';
import { ClientSmeUser, ClientUserResponse } from '../../shared/models/client-user-response.model';
import { UsersService } from 'src/app/admin/users/users.service';
import { SESSION_CONST } from 'src/app/shared/constants/session-constants';
import { SessionService } from '../../shared/session-service/session.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { role } from 'src/app/shared/constants/role-enum';
import { BaseResponse } from 'src/app/shared/models/base-response.model';
import { UserDetails } from 'src/app/core/models/user-details.model';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { APP_CONSTANTS, File_TYPE, MANAGE_CLIENT_ADMIN_USER, SUPPORTED_FILE_TYPE } from 'src/app/shared/constants/app-constants';
import { LoadingIndicatorService } from '@kpmg-tax/ui';
import { TooltipOptions } from 'ng2-tooltip-directive';
import { User } from 'src/app/core';
import { IDeleteUsersRequest } from 'src/app/admin/models/admin-client-user.model';
import { DeleteRequest } from 'src/app/shared/models/user-client/delete-request';
import { ManageClientUsersService } from './manage-client-users.service';
import { ActivatedRoute } from '@angular/router';
import { copyObject } from 'src/app/shared/lib/custom-tools';
import { FileService } from 'src/app/shared/file-service/file.service';
import { FileTypeEnum } from 'src/app/shared/constants/file-type.enum';
import { FileImportStatusEnum } from 'src/app/shared/constants/file-import-status.enum';

@Component({
    selector: 'manage-client-users',
    templateUrl: './manage-client-users.component.html',
    styleUrls: ['./manage-client-users.component.scss']
})

export class ManageClientUsersComponent implements OnInit, OnDestroy {
    fileImportStatusEnum: typeof FileImportStatusEnum = FileImportStatusEnum;
    clientUserTableColumns = [
        { name: 'Display Name', prop: 'displayName', sortable: false },
        { name: 'First Name', prop: 'firstName', sortable: false },
        { name: 'Last Name', prop: 'lastName', sortable: false },
        { name: 'Email', prop: 'emailId', sortable: false },
        { name: 'Status', prop: 'status', sortable: false }
    ];
    tableDataFiltered: ClientUserResponse[] = [];
    tableDataFilteredOriginal: ClientUserResponse[];
    @Input() drawerTitle = '';
    @Input() clientId: number;
    @Input() clientUsers: any[];
    @Input() clientName = '';
    @Output() updateClientManager = new EventEmitter<User[]>();
    @Output() updateClientAdmin = new EventEmitter<User[]>();    
    @Output() removeClientAdmin = new EventEmitter<User[]>();
    clientAdminUsers: any[] = [];    
    removeClientAdminUsers: any[] = [];
    clientManagerUsers: User[] = [];
    clients: any = [];
    selectedClient = 0;
    isSelected = false;
    selected: any[] = [];
    masterCheckboxControl = false;
    editable = new Map<number, boolean>();
    editableAlias = new Map<number, boolean>();
    editableField: any;
    selectedNickName: string;
    selectedClientName: any;
    ClientAlias: string;
    isUserListRefreshTriggered = false;
    noResults: boolean;
    noResultflag: boolean;
    engagementClient = '';
    searchFilter = '';
    clientAdmin = role.clientAdmin;
    checked: any[] = [];
    currentUserId: number;
    user: UserDetails;
    hasAdminAccess = false;
    isClientAdmin = false;
    addClientText = '';
    addBulkUserText = '';
    guidance_client_manager = MANAGE_CLIENT_ADMIN_USER.GUIDANCE_TOOLTIP_CLIENT_MANAGER;
    guidance_client_admin = MANAGE_CLIENT_ADMIN_USER.GUIDANCE_TOOLTIP_CLIENT_ADMIN;
    disableprovisionFailedUsers = false;
    toolTipOptions: TooltipOptions = { placement: 'left' } as TooltipOptions;
    private _subscriptions: Subscription[] = [];
    @Output() drawerWidthMangerClientUser = new EventEmitter<any>();
    @Input() enableBulkUser: boolean = false;
    @Input() canAddClientUsers: boolean = true;
    clientSmeUsers: ClientSmeUser[] = [];
    public statusCheckTimeout: NodeJS.Timeout;
    showDeleteUser = false;
    isStatusCheck = false;
    clientSmeUsersResponse: ClientSmeUser[];
    isAnyFailedUser = false;
    private _destroyed$ = new Subject<void>();
    engagementId: number;
    inProgressUsersCount = 0;
    failedUsersCount = 0;
    successfullUsersCount = 0;
    showAddUserOptions = false;
    clientUserImportStatus: number;
    searchString: string = '';

    constructor(private manageClientUserService: ManageClientUsersService, private _route: ActivatedRoute,
        public rightSideDrawerService: RightSideDrawerService, private _fileService: FileService,
        public toastrService: ToastrService,
        public _clientUsersService: AdminClientUsersService,
        public _usersService: UsersService,
        public sessionService: SessionService,
        private _userDataService: UserDataService,
        private _loader: LoadingIndicatorService) {
        this.clientName = this.sessionService.getSession(SESSION_CONST.CLIENTNAME);
        this.toolTipOptions.tooltipClass = "mapping-text-tooltip";
    }

    ngOnInit() {
        this.showAddUserOptions = true;
        this._route.params.pipe(takeUntil(this._destroyed$)).subscribe(params => {
            if (params) {
                this.engagementId = parseInt(params["studyId"]);
            }
        });
        this.getUserImportStatus();
        this.getClientSmeUsers();
        this.selectedClient = this.clientId;
        this.selectedClientName = this.clientName;
        this.selected = [];
        this._clientUsersService.userListRefresh.subscribe(x => {
            if (x === true) {
                this.isUserListRefreshTriggered = true;
            } else {
                this.isUserListRefreshTriggered = false;
            }
        });
        this.currentUserId = Number(
            this.sessionService.getSession('currentUserId')
        );
        this.getRoles();
        this.drawerWidthMangerClientUser.emit('calc(96vw - 100px)');
        this._subscriptions.push(
            this.rightSideDrawerService.drawerClosed.subscribe(drawerData => {
                if (drawerData?.name === APP_CONSTANTS.ADD_MULTIPLE_USERS || drawerData?.name === APP_CONSTANTS.ADD_CLIENT) {
                    this.getClientSmeUsers();
                    this.getUserImportStatus();
                }
            })
        );
        if (this.enableBulkUser) {
            this.openUserImportDrawer();
        }
    }

    getUserImportStatus() {
        this._fileService.getImportFileStatus(this.engagementId, FileTypeEnum.ClientUser).subscribe(response => {
            if (response) {
                this.clientUserImportStatus = response.importStatus;
            }
        });
    }

    openUserImportDrawer(): void {
        this.rightSideDrawerService.openRightSideDrawer('custom-uploader', APP_CONSTANTS.ADD_MULTIPLE_USERS, {
            filetype: File_TYPE.CLIENT_USER,
            isFileupload: true,
            clientId: this.clientId,
            supportedFileType: SUPPORTED_FILE_TYPE.UPLOAD,
        });
    }

    getClientSmeUsers(): void {
        this._loader.display(true);
        this.manageClientUserService.getClientSmeUsers(this.clientId, this.engagementId).subscribe(response => {
            this.clientSmeUsersResponse = response;
            this.clientSmeUsers = JSON.parse(JSON.stringify(this.clientSmeUsersResponse));
            this.setclientUsersStatus();
            this._loader.display(false);
            this.setClientUsersStatuscheck();
        });
    }

    setclientUsersStatus(): void {
        this.clientSmeUsers.forEach(user => {
            user.userStatus = user.isProvisioned ? APP_CONSTANTS.SUCCESSFUL : this.getUserProvisionStatus(user);
            user.isSelected = this.masterCheckboxControl && user.userStatus !== APP_CONSTANTS.IN_PROGRESS ? true : false;
        });
        this.setClientUsersInfo();
    }

    setClientUsersInfo(): void {
        this.isAnyFailedUser = this.clientSmeUsers.some(x => x.userStatus === APP_CONSTANTS.FAILED);
        this.inProgressUsersCount = this.clientSmeUsers.filter(x => x.userStatus === APP_CONSTANTS.IN_PROGRESS).length;
        this.failedUsersCount = this.clientSmeUsers.filter(x => x.userStatus === APP_CONSTANTS.FAILED).length;
        this.successfullUsersCount = this.clientSmeUsers.filter(x => x.userStatus === APP_CONSTANTS.SUCCESSFUL).length;
    }

    getUserProvisionStatus(user: ClientSmeUser): string {
        let statusMessage = user.stageUserId > 0 && user.errorMessage.length > 0 ? APP_CONSTANTS.FAILED : APP_CONSTANTS.IN_PROGRESS;
        return statusMessage;
    }

    getRowClass(): string {
        return 'apply-italics'
    }

    private getRoles() {
        this._userDataService.userDetails$.subscribe(userDetails => {

            this.user = userDetails;

            this.hasAdminAccess = (this.user.roleId === role.admin) || (this.user.roleId === role.champion) ? true : false;

            this.isClientAdmin = this.user.roleId === role.clientAdmin ? true : false;

            this.addClientText = this.isClientAdmin ? APP_CONSTANTS.ADD_CLIENTADMIN_USER : APP_CONSTANTS.ADD_CLIENT;

            this.addBulkUserText = this.isClientAdmin ? APP_CONSTANTS.ADD_CLIENTADMIN_BULK_CLIENT : APP_CONSTANTS.ADD_BULK_CLIENT;

            if (this.isClientAdmin) {
                this.getclientUsersforAdmin();
            }
        });

    }
    getclientUsersforAdmin() {
        this.getClientSmeUsers();
    }

    addUser = () => {
        this._clientUsersService.setFunctionTypeAndData(true, true);
        this.rightSideDrawerService.singleRowAddData = this.clientName;
        this.rightSideDrawerService.manageClientUserData = {
            clientId: this.clientId,
            clientName: this.clientName,
            isManageClientUser: true
        };
        this.rightSideDrawerService.openRightSideDrawer('add-user-form');
    };

    addBulkUser = () => {
        if (this.selectedClient === null || this.selectedClient <= 0) {
            this.toastrService.setWarningMessage('Please select a client name.');
            return;
        }
        this._clientUsersService.setFunctionTypeAndData(true, true);
        this.rightSideDrawerService.singleRowAddData = this.clientId;
        this.rightSideDrawerService.manageClientUserData = {
            clientId: this.clientId,
            clientName: this.clientName,
            isManageClientUser: true
        };
        this.rightSideDrawerService.openRightSideDrawer('custom-uploader', APP_CONSTANTS.ADD_MULTIPLE_USERS, {
            filetype: File_TYPE.CLIENT_USER,
            isFileupload: true,
            clientId: this.clientId,
            supportedFileType: SUPPORTED_FILE_TYPE.UPLOAD,
        });
    };

    saveUserDetails = (clientUser: ClientSmeUser) => {
        if (clientUser.displayName === '') {
            this.toastrService.setErrorMessage('Display name cannot be blank');
            return;
        }
        const editNameData = {
            userId: clientUser.userId > 0 ? clientUser.userId : clientUser.stageUserId,
            userName: clientUser.emailId,
            firstName: clientUser.firstName,
            lastName: clientUser.lastName,
            displayName: clientUser.displayName,
            email: clientUser.emailId,
            isStageUser: clientUser.isProvisioned ? false : true
        };
        let isUserDetailsChanged = this.isUserDetailsUpdated(clientUser);
        if (isUserDetailsChanged) {
            let preiousUserData = clientUser.isProvisioned ? this.clientSmeUsersResponse.find(x => x.userId === clientUser.userId) : this.clientSmeUsersResponse.find(x => x.stageUserId === clientUser.stageUserId);
            if (preiousUserData && (preiousUserData.firstName !== clientUser.firstName ||
                preiousUserData.lastName !== clientUser.lastName)) {
                clientUser.displayName = clientUser.firstName + ' ' + clientUser.lastName;
                editNameData.displayName = clientUser.displayName;
            }
            this._clientUsersService.updateClientUser(editNameData).subscribe(data => {
                if (data && data.success) {
                    this.toastrService.setSuccessMessage('User successfully updated.');
                    this.getClientSmeUsers();
                }
            });
        }
    };

    isUserDetailsUpdated(clientUser: ClientSmeUser): boolean {
        let preiousUserData = clientUser.isProvisioned ? this.clientSmeUsersResponse.find(x => x.userId === clientUser.userId) : this.clientSmeUsersResponse.find(x => x.stageUserId === clientUser.stageUserId);
        if (preiousUserData && (preiousUserData.displayName !== clientUser.displayName ||
            preiousUserData.firstName !== clientUser.firstName ||
            preiousUserData.lastName !== clientUser.lastName)) {
            return true;
        } else {
            return false;
        }
    }

    deleteClientUser(clientUser: ClientSmeUser) {
        this._loader.display(true, true);
        var deleteEmployeedata = [];
        deleteEmployeedata.push({
            userId: clientUser.isProvisioned ? clientUser.userId : clientUser.stageUserId, userName: clientUser.emailId, email: clientUser.emailId,
            IsStageUser: clientUser.errorMessage !== '' ? true : false, clientId: this.clientId ? this.clientId : 0
        });
        let deleteusersRequest: IDeleteUsersRequest[] = [];
        this._usersService.sendRequestforDeletion(deleteEmployeedata).subscribe(data => {
            if (data) {
                if (deleteusersRequest.length > 0) {
                    this._usersService.deleteUsersFromAD(deleteusersRequest);
                }
                const message = data?.success ? Messages.Admin.User.DeleteUserAPISuccess : Messages.Admin.User.DeleteUserAPIFailure;
                this.deletionCompleted(message);
                this._loader.display(false);
            }
        });
    };


    selectSingle(clientUser: ClientSmeUser) {
        this.masterCheckboxControl = false;
        this.showDeleteUser = this.clientSmeUsers.some(x => x.isSelected) ? true : false;
        this.showAddUserOptions = !this.showDeleteUser;
        this.clientSmeUsersResponse.map(user => {
            if (user.isProvisioned) {
                user.isSelected = user.userId === clientUser.userId ? clientUser.isSelected : user.isSelected;
            } else {
                user.isSelected = user.stageUserId === clientUser.stageUserId ? clientUser.isSelected : user.isSelected;
            }
        })
    }

    selectMultiple() {
        this.masterCheckboxControl = !this.masterCheckboxControl;
        this.showDeleteUser = this.masterCheckboxControl;
        this.clientSmeUsers.forEach(user => {
            user.isSelected = this.masterCheckboxControl && user.userStatus !== 'In Progress' ? true : false;
        });
        this.clientSmeUsersResponse.forEach(user => {
            user.isSelected = this.masterCheckboxControl && user.userStatus !== 'In Progress' ? true : false;
        });
        this.showAddUserOptions = !this.showDeleteUser;
    }

    sendDeletionRequest() {
        this._loader.display(true, true);
        let deleteUsersRequestFromAD: IDeleteUsersRequest[] = [];
        let deleteUsersrequest: DeleteRequest[] = [];
        this.clientSmeUsers.forEach(clientUser => {
            if (clientUser.isSelected) {
                deleteUsersrequest.push({
                    userId: clientUser.isProvisioned ? clientUser.userId : clientUser.stageUserId,
                    userName: clientUser.emailId,
                    clientId: this.clientId,
                    isStageUser: clientUser.isProvisioned ? false : true,
                    email: clientUser.emailId
                })
            }
        });
        this._usersService.sendRequestforDeletion(deleteUsersrequest).subscribe(data => {
            if (data?.success) {
                if (deleteUsersRequestFromAD.length > 0) {
                    this._usersService.deleteUsersFromAD(deleteUsersRequestFromAD);
                }
                const message = data?.success ? Messages.Admin.User.DeleteUserAPISuccess : Messages.Admin.User.DeleteUserAPIFailure;
                this.deletionCompleted(message);
                this._loader.display(false);
            }
        });
    }

    private deletionCompleted(message: string) {
        this.showDeleteUser = false;
        this.showAddUserOptions = true;
        this.toastrService.setSuccessMessage(message);
        this.selected = [];
        this.isSelected = false;
        this.masterCheckboxControl = false;
        this.getClientSmeUsers();
    }

    filterClientUsers(searchText: string) {
        let clientSmeUSers: ClientSmeUser[] = copyObject(this.clientSmeUsersResponse);
        if (this.showDeleteUser) {
            clientSmeUSers.forEach(user => {
                let clientUserSelected = this.clientSmeUsers.find(x => x.isProvisioned ? x.userId === user.userId : user.stageUserId);
                user.isSelected = clientUserSelected && clientUserSelected.isSelected ? true : false;
            });
        }
        const filterInputValue = searchText.trim().toUpperCase();
        this.searchString = filterInputValue;
        this.searchFilter = filterInputValue;
        let filteredUsers = clientSmeUSers.filter(d => d !== null &&
            (d.emailId.toString().toUpperCase().indexOf(filterInputValue) !== -1 ||
                d.displayName.toString().toUpperCase().indexOf(filterInputValue) !== -1 ||
                d.firstName.length > 0 && d.firstName.toString().toUpperCase().indexOf(filterInputValue) !== -1 ||
                d.lastName.length > 0 && d.lastName.toString().toUpperCase().indexOf(filterInputValue) !== -1 ||
                d.userStatus && d.userStatus.length > 0 && d.userStatus.toString().toUpperCase().indexOf(filterInputValue) !== -1));
        this.clientSmeUsers = copyObject(filteredUsers);
        this.setclientUsersStatus();
    };

    editUserDetails(rowNumber: number, editField: string): void {
        document.getElementById(editField + rowNumber).focus();
    }

    editClick(rowindex): void {
        this.editableField = rowindex;
        if (this.editable[rowindex] === false) {
            document.getElementById(rowindex).focus();
            this.editable[rowindex] = true;
        } else {
            document.getElementById(rowindex).focus();
            this.editable[rowindex] = false;
        }
    }

    editFirstOrLastName(elementIndex: number, column: string): void {
        const columnElement: HTMLElement = document.getElementById(elementIndex.toString() + column);
        if (columnElement) {
            columnElement.focus();
        }
    }

    updateDisplayName(event, row): void {
        if (event) {
            const currentDisplayName = row.displayName;
            row.displayName = row.firstName?.trim() + ' ' + row.lastName?.trim();
            row.displayName = row.displayName === undefined ? '' : row.displayName;
            if (row.displayName?.trim().length == 0) {
                row.displayName = currentDisplayName;
            }
        }
    }

    hideClearButton = false;

    addClientManager(event, row: any) {
        if (event.target.checked === true) {
            row.roleIds.push(role.clientManager);
            this.clientUsers.push(row);
            this.toastrService.setInfoMessage(Messages.Home.ClientUserSelectionInfo);
        } else {
            row.roleIds = row.roleIds.filter(x => x !== role.clientManager);
            const index = this.clientUsers.findIndex(item => item.userId === row.userId);
            if (index !== -1) {
                this.clientUsers.splice(index, 1);
            }
        }
        this.updateClientManager.emit(this.clientUsers);
    }

    addClientAdmin(event, row: any) {
        if (event.target.checked === true) {
            row.roleIds.push(role.clientAdmin);
            this.clientAdminUsers.push(row);
            const indexCA = this.removeClientAdminUsers.findIndex(item => item.userId === row.userId);
            if (indexCA !== -1) {
                this.removeClientAdminUsers.splice(indexCA, 1);
            }
            this.toastrService.setInfoMessage(Messages.Home.ClientUserSelectionInfo);
        } else {
            row.roleIds = row.roleIds.filter(x => x !== role.clientAdmin);
            this.removeClientAdminUsers.push(row);
            const index = this.clientUsers.findIndex(item => item.userId === row.userId);
            if (index !== -1) {
                this.clientUsers.splice(index, 1);
            }
            const indexAdmin = this.clientAdminUsers.findIndex(item => item.userId === row.userId);
            if (indexAdmin !== -1) {
                this.clientAdminUsers.splice(indexAdmin, 1);
            }
        }
        this.updateClientManager.emit(this.clientUsers);
        this.updateClientAdmin.emit(this.clientAdminUsers);
        this.removeClientAdmin.emit(this.removeClientAdminUsers);
    }

    roleCheckValue(event, row: any, roleInput: string) { 
        const ClientData = {
            userId: row.userId,
            userName: row.userName,
            roleId: null,
            isSelected: event.target.checked
        };
        if (roleInput === 'clientadmin') {
            ClientData.roleId = role.clientAdmin;
        }
        if (event.target.checked === true) {
            this.checked.push(row);

        } else {
            const filtered = this.checked.filter(item => item.userId !== row.userId);
            this.checked = [];
            this.checked = filtered;

        }
        this._usersService.AddUpdateRole(ClientData).subscribe((data: BaseResponse) => {
            if (data.success) {
                this.getClientSmeUsers();
                this.toastrService.setSuccessMessage(Messages.Admin.User.UpdateUserRoleSuccess);
            } else {
                this.toastrService.setErrorMessage(Messages.Admin.User.UpdateUserRoleFailure);
            }
        }
        );
    }
    getClientAdminRole(clientUser: ClientSmeUser) {
        return clientUser.roleIds === null ? false : clientUser.roleIds.some(x => x === role.clientAdmin);
    }

    getClientManagerRole(clientSmeUser: ClientSmeUser) {
        return clientSmeUser.roleIds === null ? false : clientSmeUser.roleIds.some(x => x === role.clientManager);
    }
    provisionFailedUsers() {
        this._loader.display(true, true);
        this._clientUsersService.provisionFailedUsers(this.clientId).subscribe(response => {
            if (response) {
                this.getClientSmeUsers();
                this.toastrService.setSuccessMessage(APP_CONSTANTS.CLIENT_USER_RETRY_SUCCESS);
                this.isAnyFailedUser = false;
                this.setClientUsersStatuscheck();
            }
        });
    }

    setClientUsersStatuscheck(): void {
        if (this.clientSmeUsers.some(x => !x.isProvisioned && x.errorMessage.length === 0)) {
            this.setStatusCheckTimeout();
        } else {
            this.clearStatusCheckTimeout();
        }
    }

    setStatusCheckTimeout(): void {
        this.isStatusCheck = true;
        this.statusCheckTimeout = setTimeout(() => this.getClientUsersStatus(true), 5000);
    }

    getClientUsersStatus(isRefreshed: boolean): void {
        this.manageClientUserService.getClientUsersStatus(this.clientId, this.engagementId).subscribe(statusResponse => {
            let clientUsers: ClientSmeUser[] = statusResponse;
            if(isRefreshed){
                this.UpdateClientUserObject(clientUsers);
            }else{
                this.clientSmeUsers = copyObject(clientUsers);
            }
            this.clientSmeUsersResponse = copyObject(clientUsers);
            this.setclientUsersStatus();
            if (this.searchString.length > 0) {
                this.filterClientUsers(this.searchString);
            }
            this.setClientUsersStatuscheck();
        });
    }

    UpdateClientUserObject(clientUsers: ClientSmeUser[]): void{
        let clientInProgressSMEUsers: ClientSmeUser[] = this.clientSmeUsers.filter(x => !x.isProvisioned && x.errorMessage.length === 0);
        
        if(clientInProgressSMEUsers.length > 0){
            let clientUpdatedUsers: ClientSmeUser[] = clientUsers.filter(x => clientInProgressSMEUsers.some(y => y.emailId === x.emailId));
            this.clientSmeUsers.forEach(item => {
                let found:ClientSmeUser = clientUpdatedUsers.find(el => el.emailId === item.emailId);
                if(found){
                    item.errorMessage = found.errorMessage; 
                    item.isProvisioned = found.isProvisioned;
                    item.isValidUser = found.isValidUser;
                    item.roleIds = found.roleIds;
                    item.stageUserId = found.stageUserId;
                    item.userId = found.userId;
                }
             });
        }
    }

    clearStatusCheckTimeout() {
        this.isStatusCheck = false;
        if (this.statusCheckTimeout) {
            clearTimeout(this.statusCheckTimeout);
        }
    }

    ngOnDestroy() {
        this.clearStatusCheckTimeout();
        this.rightSideDrawerService.closeRightSideDrawer();
        this._subscriptions.forEach(s => s.unsubscribe());
    }
}
